import Axios from '@/common/require'
export default {
  // 人才库
  GET_LOCAL_SUGGEST(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/local/suggest',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  GET_LOCAL_LIST(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/local/index',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // mis
  GET_MIS_LIST(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/local/search',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },

  //导入mis系统
  POST_MIS(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/local/post_mis',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 获取标签树
  GET_TYPE_LIST(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/local/type_list',
        data,
        options: {
          method: 'post',
          load: 0,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 添加标签
  ADD_LABEL(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/console/local/add',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 删除标签
  DELETE_LABEL(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/console/local/del',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 更新标签
  UPDATA_LABEL(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/console/local/update',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 本地搜索导出导出
  EXPORT_LIST(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/local/export',
        data : {
          ...data, 
          ischeck:0
        },
        options:{
          method:'post',
          load:1,
          excel:1
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 上传简历
  UPDATA_RESUME(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/console/local/upload',
        data,
        options:{
          method:'post',
          load:1,
          json:0,
          file:1
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 批量上传简历
  UPDATA_RESUME_MUL(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/console/local/uploads',
        data,
        options:{
          method:'post',
          load:1,
          json:0,
          file:1
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },

  // 领英搜索
  GET_LINKEDIN_LIST(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/linkedin/index',
        data,
        options:{
          method:'post',
          load:1,
          json:0,
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 领英导出
  EXPORT_LINKEDIN_LIST(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/linkedin/export',
        data:{
          ...data,
          ischeck:0
        },
        options:{
          method:'post',
          load:1,
          excel:1
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 领英订阅
  SET_SUBSCRIPT(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/linkedin/subscribe',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },


  // mis 详情
  GET_MIS_DETAIL(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/local/mdetail`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 人才库详情
  GET_RESUME_DETAIL(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/local/detail`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 人才库详情 更新
  UPDATA_RESUME_DETAIL(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:'/api.php/console/local/update',
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 人才详情  打标签
  ADD_RESUME_LABEL(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/console/local/add_tag`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  DEL_RESUME_LABEL(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/console/local/del_tag`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 人才详情 职位列表
  GET_POSITION_LIST(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/console/local/job_list`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 人才详情 加入职位
  POST_RESUME(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/console/local/post`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 人才详情 关注  取消关注
  SET_PEG(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/local/peg`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 删除人才
  DEL_RESUME(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/local/del_person`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/resumes/actions.js